module.exports = __webpack_public_path__ + "static/media/cartagena-25.8597bdbc.jpg";